'use strict';

export default {

    NONE: null,
    OTHER: 'OTHER',

    IMAGE: 'IMAGE',
    AUDIO: 'AUDIO',
    VIDEO: 'VIDEO',
    DOCUMENT: 'DOCUMENT'
}